export const TitleProp = Object.freeze({
    Text: 'text',
    TextSize: 'textSize',
    TextAlign: 'textAlign',
    TextColor: 'textColor',
    IconName: 'iconName',
});